export default __webpack_public_path__ + "static/media/grayPencilIcon.1ac5ae69.svg";